export const initialState = {
  is_bundle_delivery: 'Y',
  forwarding_location_id: null,
  is_store_pickup: 'N',
  forwarding_information: '',
  forwarding_date: 0,
  packaging_method: 'GENERAL',
  receive_ids: null,
};

export const productDeliveryReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_IS_BUNDLE_DELIVERY':
      return {
        ...state,
        is_bundle_delivery: action.value,
      };
    case 'CHANGE_FORWADING_LOCATION_ID':
      return {
        ...state,
        forwarding_location_id: action.value,
      };
    case 'CHANGE_IS_STORE_PICKUP':
      return {
        ...state,
        is_store_pickup: action.value,
      };
    case 'CHANGE_FORWADING_INFORMATION':
      return {
        ...state,
        forwarding_information: action.value,
      };
    case 'CHANGE_FORWARDING_DATE':
      return {
        ...state,
        forwarding_date: action.value,
      };
    case 'CHANGE_PACKAGING_METHOD':
      return {
        ...state,
        packaging_method: action.value,
      };

    case 'receive_ids':
      return {
        ...state,
        receive_ids: action.value,
      };
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
};
